import { FC, useCallback, useState } from 'react';
import Journey from './Charts/Journey';
import { GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import PurchaseOrder from './Charts/PurchaseOrder'
import { useHistory } from 'react-router-dom';
import PalletDetail from './Charts/PalletDetail';
import StoreOrder from './Charts/StoreOrder';
import StuntType from './Charts/StuntType';
import StoreOrderIssue from './Charts/StoreOrderIssue';

const Dashboard: FC = () => {
    const [stuntType, setStuntType] = useState('/All')
    const history = useHistory()
    const onChartClick = useCallback((chartType: string) => {
        switch (chartType) {
            case 'purchaseorders':
                history.push(`/purchaseorders`)
                break;
            case 'journey':
                history.push(`/journey`)
                break;
            case 'palletdetail':
                history.push(`/palletdetail`)
                break;
            case 'storeorders':
                history.push(`/storeorders`)
                break;

            default:
                history.push(`/purchaseorders`)
                break;
        }
    }, [history])

    const childToParent = (value: any) => {
        if (value === "") {
            setStuntType('/All')
        } else {
            setStuntType(`/${value}`)
        }

    }

    return (
        <>
            <div className="">
                <div className='floatLeft'><h3> My Dashboard </h3></div>
                <div className='floatRight'><StuntType childToParent={childToParent} /></div>

                <GridWrapper equalHeight>
                    <GridItem size="1/2">
                        <div className="" onClick={() => onChartClick('purchaseorders')}>
                            <h4 className="">Purchase Order </h4>
                            <div style={{ borderTop: '1px solid #646464' }}>
                                <PurchaseOrder stuntType={stuntType} />
                            </div>
                        </div>
                    </GridItem>
                    <GridItem size="1/2">
                        <div className="" onClick={() => onChartClick('journey')}>
                            <h4 className="">Journey</h4>
                            <div style={{ borderTop: '1px solid #646464' }}>
                                <Journey stuntType={stuntType} />
                            </div>
                        </div>
                    </GridItem>
                </GridWrapper>
                <div>&nbsp;</div>

                <GridWrapper equalHeight>
                    <GridItem size="1/2">
                        <div className="" onClick={() => onChartClick('palletdetail')}>
                            <h4 className="">Pallet Detail </h4>
                            <div style={{ borderTop: '1px solid #646464' }}>
                                <PalletDetail stuntType={stuntType} />
                            </div>
                        </div>
                    </GridItem>
                    <GridItem size="1/2">
                        <div className="" onClick={() => onChartClick('storeorders')}>
                            <h4 className="">Store Order</h4>
                            {/* <div style={{ height: '100%', width: '100%', display:'flex', style={{flexGrow: 1}}}}> */}
                            <div style={{ height: '89%', display: 'flex', borderTop: '1px solid #646464' }}>
                                <div className='flexItem1 colour'>
                                    <StoreOrder stuntType={stuntType} />
                                </div>
                                <div className='flexItem2 colour'>
                                    <StoreOrderIssue stuntType={stuntType} />
                                </div>
                            </div>
                        </div>
                    </GridItem>
                </GridWrapper>

                {/* <div className="" onClick={() => onChartClick('storeorders')}>
                    <h4 className="">Store Order</h4>
                    <div style={{ border: 'solid', display: 'flex' }}>
                        <div style={{ width:'50%' }}>
                            <StoreOrder stuntType={stuntType} />
                        </div>
                        <div style={{ width:'50%',height: '100%'}}>
                            <StoreOrderIssue stuntType={stuntType} />
                        </div>


                    </div>
                </div> */}
            </div>
        </>
    )
}

export default Dashboard;